import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { Router } from '@angular/router';
import { CommonStoreService } from 'src/app/services/common-store.service';

export const selectLocationGuard: CanActivateFn = () => {
  const store = inject(CommonStoreService);
  const router = inject(Router);
  if (store.getSelectedAddressSnapshot()) {
    return true;
  }
  return router.createUrlTree(['']);
};
